import React from 'react';
import Header from './Header';
import Footer from './Footer';

const Layout = ({ children, withFooter = true }) => (
  <div className="min-h-screen bg-stone-50 text-stone-800 dark:bg-stone-950 dark:text-stone-100" dir="rtl">
    <Header />
    <main>{children}</main>
    {withFooter && <Footer />}
  </div>
);

export default Layout;
